import shared from "emun.customer/customer.config.es6";

export default Object.assign(shared, {
  customerExportTemplate: "CustomersExport",
  customerExportOrigin: "A2",
  showBulkActions: true,
  listFields: "Id,CompanyName,Address,City,State,Zip,Email,Phone,Status,SalesRepName",
  addressVerification: true
});
